import axios from 'axios';

/**
 * Request payload for online model update
 */
export interface OnlineUpdateRequest {
  symbol: string;
  features: Record<string, any>;
}

/**
 * Drift metrics returned by backend
 */
export interface DriftMetrics {
  driftScore: number;
  [key: string]: any;
}

/**
 * Send new features to backend for online learning update.
 */
export async function updateOnlineModel(
  symbol: string,
  features: Record<string, any>
): Promise<void> {
  try {
    await axios.post('/api/online/update', { symbol, features });
  } catch (error) {
    console.error('Error updating online model:', error);
  }
}

/**
 * Fetch current model drift metrics from backend.
 */
export async function fetchDriftMetrics(): Promise<DriftMetrics | null> {
  try {
    const response = await axios.get<DriftMetrics>('/api/online/drift');
    return response.data;
  } catch (error) {
    console.error('Error fetching drift metrics:', error);
    return null;
  }
}